export default __webpack_public_path__ + "static/media/user-01.7df6c698.jpg";